<lib-ph-bhp-sop [userData]="appConfig.userData" (childData)="childData($event)"></lib-ph-bhp-sop>